
export default {
    data () {
        return {
					timestamp: null,
					sensorIds: [],
					refreshRate: -1,
					title1Size: 30,
					title2Size: 8,
					textSize: 0,
					font: null,
					height: 30,
					jsonEntities: [],
        }
    },
    methods: {
			buildTicket(timestamp, sensorIds, refreshRate, data) {
					this.timestamp = timestamp;
					this.sensorIds = sensorIds;
					this.refreshRate = refreshRate;

					this.jsonEntities = [];

					this.buildTicketHeader();

					this.parseTemperatures(data);					

					this.buildDottedLine();
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.date') + this.formatLocalDateTime(new Date()) + ' CET', this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));

					return this.jsonEntities;
				},
				buildDottedLine() {
					this.jsonEntities.push(this.buildJSONEntity('--------------------------------', this.textSize, 0));
				},
				buildTicketHeader() {					
					this.jsonEntities.push(this.buildJSONEntity('WEMOB', this.title1Size, 1));	
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));			
					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.title'), this.title2Size, 1));
					this.buildDottedLine();

					var mobileData = this.$store.state.wedrive.mobileData;
					var index = this.$store.state.wedrive.mobileIndex;

					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.company') + mobileData[index].aliasFleet[0], this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));			
					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.vehicle') + mobileData[index].aliasMobile[0], this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));			

					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.start-date') + this.formatLocalDateTimeWithoutSeconds(parseInt(this.timestamp.init)), this.textSize, 0));
					//this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));			
					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.end-date') + this.formatLocalDateTimeWithoutSeconds(parseInt(this.timestamp.end)), this.textSize, 0));
					//this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));		
					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.sensors') + this.parseSensors(), this.textSize, 0));
					//this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));	
					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.refresh-rate') + this.refreshRate + ' min.', this.textSize, 0));
					this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));

					this.jsonEntities.push(this.buildJSONEntity(this.$t('print.ticket.note'), this.textSize, 0));
					//this.jsonEntities.push(this.buildJSONEntity('', this.textSize, 0));			
				},
				parseSensors() {
						var sensors = '';		
				
						if (this.sensorIds.findIndex(x => x.value ? x.value == 1 : x == 1) != -1) {   
								sensors += '1';
						}
						if (this.sensorIds.findIndex(x => x.value ? x.value == 2 : x == 2) != -1) {    
								if (sensors.length > 0) {
									sensors += ', ';
								}
								sensors += '2';
						}
						if (this.sensorIds.findIndex(x => x.value ? x.value == 3 : x == 3) != -1) {   
								if (sensors.length > 0) {
									sensors += ', ';
								}
								sensors += '3';
						}
						if (this.sensorIds.findIndex(x => x.value ? x.value == 4 : x == 4) != -1) {    
								if (sensors.length > 0) {
									sensors += ', ';
								}
								sensors += '4';
						}

						return '[ ' + sensors + ' ]';
				},
				parseTemperatures(data) {
						if (!data || data.length == 0) {
								return;
						}

						var timestamp = null;
						
						for (var i = 0; i < data.length; i++) {
								if (data[i].length == 0) {
										continue;
								}

								if (!timestamp || this.isNewDay(timestamp, data[i].timestamp)) {
										this.buildDataHeader(data[i]);
										timestamp = data[i].timestamp;
								}

								var header = this.formatLocalTimeWithoutSeconds(parseInt(data[i].timestamp)) + '   ';								
								if (this.sensorIds.findIndex(x => x.value ? x.value == 1 : x == 1) != -1) {   
										header += this.parseTemperature(data[i].temperature1);
								}
								if (this.sensorIds.findIndex(x => x.value ? x.value == 2 : x == 2) != -1) {    
										header += this.parseTemperature(data[i].temperature2);
								}
								if (this.sensorIds.findIndex(x => x.value ? x.value == 3 : x == 3) != -1) {   
										header += this.parseTemperature(data[i].temperature3);
								}
								if (this.sensorIds.findIndex(x => x.value ? x.value == 4 : x == 4) != -1) {    
										header += this.parseTemperature(data[i].temperature4);
								}
								
								this.jsonEntities.push(this.buildJSONEntity(header, this.textSize, 0));
						}
				},
				isNewDay(lastTimestamp, currentTimestamp) {
					var date1 = this.parseLocalDateTime(parseInt(lastTimestamp));
					var date2 = this.parseLocalDateTime(parseInt(currentTimestamp));

					var date1_tomorrow = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate() + 1);
					if (date1_tomorrow.getFullYear() == date2.getFullYear() && date1_tomorrow.getMonth() == date2.getMonth() && date1_tomorrow.getDate() == date2.getDate()) {
							return true;
					}

					return false;
				},
				buildDataHeader(data) { 
					this.buildDottedLine();
					this.jsonEntities.push(this.buildJSONEntity(this.formatLocalDate(parseInt(data.timestamp)), this.textSize, 0));

					var header = '';
					header += this.$t('print.ticket.time');
					header += '    ';
					if (this.sensorIds.findIndex(x => x.value ? x.value == 1 : x == 1) != -1) {          
							header += '#1    ';
					}
					if (this.sensorIds.findIndex(x => x.value ? x.value == 2 : x == 2) != -1) {          
							header += '#2    ';
					}
					if (this.sensorIds.findIndex(x => x.value ? x.value == 3 : x == 3) != -1) {       
							header += '#3    ';
					}
					if (this.sensorIds.findIndex(x => x.value ? x.value == 4 : x == 4) != -1) {            
							header += '#4';
					}

					this.jsonEntities.push(this.buildJSONEntity(header, this.textSize, 0));
				},
				parseTemperature(value) {
					var temp = parseInt(value);
					
					if (temp <= -1000) {
							return '--    ';
					}

					var str = (temp / 10).toFixed(1);
					
					return str.padEnd(6, ' ');
				},
				buildJSONEntity(data, size, align) {
					return {
						data: data,
						size: size,
						align: align,
						font: this.font,
						height: this.height
					};
				}
		}
}